import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48">
    <rect width="48" height="48" fill="#CDE4DD" rx="10"></rect>
    <path
      fill="#057953"
      d="M23.999 12.336c-6.44 0-11.667 5.227-11.667 11.667s5.227 11.666 11.667 11.666 11.666-5.226 11.666-11.666S30.44 12.336 24 12.336m0 7.875a.88.88 0 0 1-.875-.875c0-.478.396-.875.875-.875a5.547 5.547 0 0 1 5.541 5.542A5.547 5.547 0 0 1 24 29.544a.88.88 0 0 1-.875-.875c0-.478.396-.875.875-.875a3.8 3.8 0 0 0 3.791-3.791A3.8 3.8 0 0 0 24 20.21m0 12.833c-4.982 0-9.042-4.06-9.042-9.041 0-.479.397-.875.875-.875s.875.396.875.875a7.294 7.294 0 0 0 7.292 7.291 7.294 7.294 0 0 0 7.291-7.291A7.294 7.294 0 0 0 24 16.71a.88.88 0 0 1-.875-.875c0-.478.396-.875.875-.875 4.981 0 9.041 4.06 9.041 9.042 0 4.981-4.06 9.041-9.041 9.041"></path>
  </svg>
);

export default SvgIcon;
